<template>
  <div class="page-wrapper">
    <div class="page-head">
      <h1>{{ $vuetify.lang.t('$vuetify.menu.objects') }}</h1>

      <div class="page-head__buttons">
        <button class="btn-secondary btn" @click="arch = !arch; page=1">
          <span v-if="!arch">{{ $vuetify.lang.t('$vuetify.archive') }}</span>
          <span v-else>{{ $vuetify.lang.t('$vuetify.outArchive') }}</span>
        </button>
        <button class="btn-secondary btn" @click="inviteMode=!inviteMode; page=1" v-if="invitations.length">
          <span v-if="!inviteMode">{{ $vuetify.lang.t('$vuetify.invitations') }} ({{ invitations.length }})</span>
          <span v-else>{{ $vuetify.lang.t('$vuetify.back') }}</span>
        </button>
        <button v-if="permissions.edit.indexOf('Объекты') != -1" class="btn-secondary btn" @click="object_create_open">
          + {{ $vuetify.lang.t('$vuetify.addObject') }}
        </button>
      </div>
    </div>

    <div class="page-head page-head--sorts" v-if="!inviteMode">
      <div class="page__sorts">
        <v-text-field class="search-field" v-model="search" @keypress.enter="page=1; loadData()"
                      @keypress.tab="page=1; loadData()" enterkeyhint="search"
                      :placeholder="$vuetify.lang.t('$vuetify.sorts.searchObject')" outlined
                      prepend-inner-icon="$search" hide-details>
        </v-text-field>
        <v-autocomplete v-model="filter.client" :label="$vuetify.lang.t('$vuetify.company')"
                        :items="clients" item-text="name" item-value="id" outlined hide-details attach
                        @change="loadData" clearable
                        :menu-props="{
              bottom: true,
              offsetY: true,
              axHeight: width<1024 ? 300 : 800,
              contentClass: 'select-menu  select-menu--sort',
            }"></v-autocomplete>
        <v-select class="sorts__select" :class="{ show: type == 'cards' }" v-model="sort"
                  :label="$vuetify.lang.t('$vuetify.dataTable.sortBy')"
                  :items="selectSorts" item-text="name" item-value="value"
                  :menu-props="{
                                      bottom: true,
                                      offsetY: true,
                                      maxHeight: 200,
                                      contentClass: 'select-menu select-menu--sort',
                                  }" outlined hide-details attach>

          <template v-slot:selection="{item }">
            {{ $vuetify.lang.t("$vuetify.sorts." + item.type) }}
            {{ $vuetify.lang.t("$vuetify." + item.direction) }}
          </template>
          <template v-slot:item="{ item }">
            {{ $vuetify.lang.t("$vuetify.sorts." + item.type) }}
            {{ $vuetify.lang.t("$vuetify." + item.direction) }}
          </template>
        </v-select>
      </div>
      <div class="page-head--right">
        <per-page-select v-model="perPage"></per-page-select>
        <div class="type-switcher">
          <div class="type-switcher__item" :class="{ show: type == 'rows' }" @click="type = 'rows'">
            <svg width="34" height="34" viewBox="0 0 34 34" fill="none" xmlns="http://www.w3.org/2000/svg">
              <rect x="0.5" y="0.5" width="33" height="33" rx="4.5"/>
              <path
                d="M9.20039 9.7998C8.723 9.7998 8.26516 9.98945 7.9276 10.327C7.59003 10.6646 7.40039 11.1224 7.40039 11.5998V13.9998C7.40039 14.4772 7.59003 14.935 7.9276 15.2726C8.26516 15.6102 8.723 15.7998 9.20039 15.7998H11.6004C12.0778 15.7998 12.5356 15.6102 12.8732 15.2726C13.2107 14.935 13.4004 14.4772 13.4004 13.9998V11.5998C13.4004 11.1224 13.2107 10.6646 12.8732 10.327C12.5356 9.98945 12.0778 9.7998 11.6004 9.7998H9.20039ZM8.60039 11.5998C8.60039 11.4407 8.6636 11.2881 8.77613 11.1755C8.88865 11.063 9.04126 10.9998 9.20039 10.9998H11.6004C11.7595 10.9998 11.9121 11.063 12.0247 11.1755C12.1372 11.2881 12.2004 11.4407 12.2004 11.5998V13.9998C12.2004 14.1589 12.1372 14.3115 12.0247 14.4241C11.9121 14.5366 11.7595 14.5998 11.6004 14.5998H9.20039C9.04126 14.5998 8.88865 14.5366 8.77613 14.4241C8.6636 14.3115 8.60039 14.1589 8.60039 13.9998V11.5998ZM16.4004 10.9998C16.2413 10.9998 16.0886 11.063 15.9761 11.1755C15.8636 11.2881 15.8004 11.4407 15.8004 11.5998C15.8004 11.7589 15.8636 11.9115 15.9761 12.0241C16.0886 12.1366 16.2413 12.1998 16.4004 12.1998H26.0004C26.1595 12.1998 26.3121 12.1366 26.4247 12.0241C26.5372 11.9115 26.6004 11.7589 26.6004 11.5998C26.6004 11.4407 26.5372 11.2881 26.4247 11.1755C26.3121 11.063 26.1595 10.9998 26.0004 10.9998H16.4004ZM16.4004 13.3998C16.2413 13.3998 16.0886 13.463 15.9761 13.5755C15.8636 13.6881 15.8004 13.8407 15.8004 13.9998C15.8004 14.1589 15.8636 14.3115 15.9761 14.4241C16.0886 14.5366 16.2413 14.5998 16.4004 14.5998H23.6004C23.7595 14.5998 23.9121 14.5366 24.0247 14.4241C24.1372 14.3115 24.2004 14.1589 24.2004 13.9998C24.2004 13.8407 24.1372 13.6881 24.0247 13.5755C23.9121 13.463 23.7595 13.3998 23.6004 13.3998H16.4004ZM9.20039 18.1998C8.723 18.1998 8.26516 18.3894 7.9276 18.727C7.59003 19.0646 7.40039 19.5224 7.40039 19.9998V22.3998C7.40039 22.8772 7.59003 23.335 7.9276 23.6726C8.26516 24.0102 8.723 24.1998 9.20039 24.1998H11.6004C12.0778 24.1998 12.5356 24.0102 12.8732 23.6726C13.2107 23.335 13.4004 22.8772 13.4004 22.3998V19.9998C13.4004 19.5224 13.2107 19.0646 12.8732 18.727C12.5356 18.3894 12.0778 18.1998 11.6004 18.1998H9.20039ZM8.60039 19.9998C8.60039 19.8407 8.6636 19.6881 8.77613 19.5755C8.88865 19.463 9.04126 19.3998 9.20039 19.3998H11.6004C11.7595 19.3998 11.9121 19.463 12.0247 19.5755C12.1372 19.6881 12.2004 19.8407 12.2004 19.9998V22.3998C12.2004 22.5589 12.1372 22.7115 12.0247 22.8241C11.9121 22.9366 11.7595 22.9998 11.6004 22.9998H9.20039C9.04126 22.9998 8.88865 22.9366 8.77613 22.8241C8.6636 22.7115 8.60039 22.5589 8.60039 22.3998V19.9998ZM16.4004 19.3998C16.2413 19.3998 16.0886 19.463 15.9761 19.5755C15.8636 19.6881 15.8004 19.8407 15.8004 19.9998C15.8004 20.1589 15.8636 20.3115 15.9761 20.4241C16.0886 20.5366 16.2413 20.5998 16.4004 20.5998H26.0004C26.1595 20.5998 26.3121 20.5366 26.4247 20.4241C26.5372 20.3115 26.6004 20.1589 26.6004 19.9998C26.6004 19.8407 26.5372 19.6881 26.4247 19.5755C26.3121 19.463 26.1595 19.3998 26.0004 19.3998H16.4004ZM16.4004 21.7998C16.2413 21.7998 16.0886 21.863 15.9761 21.9755C15.8636 22.0881 15.8004 22.2407 15.8004 22.3998C15.8004 22.5589 15.8636 22.7115 15.9761 22.8241C16.0886 22.9366 16.2413 22.9998 16.4004 22.9998H23.6004C23.7595 22.9998 23.9121 22.9366 24.0247 22.8241C24.1372 22.7115 24.2004 22.5589 24.2004 22.3998C24.2004 22.2407 24.1372 22.0881 24.0247 21.9755C23.9121 21.863 23.7595 21.7998 23.6004 21.7998H16.4004Z"
                fill="#2A3F57"/>
              <rect x="0.5" y="0.5" width="33" height="33" rx="4.5" stroke="#2A3F57"/>
            </svg>
          </div>
          <div class="type-switcher__item" :class="{ show: type == 'cards' }" @click="type = 'cards'">
            <svg width="34" height="34" viewBox="0 0 34 34" fill="none" xmlns="http://www.w3.org/2000/svg">
              <path fill-rule="evenodd" clip-rule="evenodd"
                    d="M15.5738 8.86902C14.9918 8.3126 14.2024 8 13.3793 8H11.1034C10.2804 8 9.49099 8.3126 8.90898 8.86902C8.32697 9.42545 8 10.1801 8 10.967V13.5385C8 14.3254 8.32697 15.08 8.90898 15.6365C9.49099 16.1929 10.2804 16.5055 11.1034 16.5055H13.3793C14.2024 16.5055 14.9918 16.1929 15.5738 15.6365C16.1558 15.08 16.4828 14.3254 16.4828 13.5385V10.967C16.4828 10.1801 16.1558 9.42545 15.5738 8.86902ZM9.24138 13.5385V10.967C9.24138 10.4949 9.43756 10.0421 9.78677 9.70823C10.136 9.37437 10.6096 9.18681 11.1034 9.18681H13.3793C13.8732 9.18681 14.3468 9.37437 14.696 9.70823C15.0452 10.0421 15.2414 10.4949 15.2414 10.967V13.5385C15.2414 14.0106 15.0452 14.4634 14.696 14.7973C14.3468 15.1311 13.8732 15.3187 13.3793 15.3187H11.1034C10.6096 15.3187 10.136 15.1311 9.78677 14.7973C9.43756 14.4634 9.24138 14.0106 9.24138 13.5385Z"
                    fill="#2A3F57"/>
              <path fill-rule="evenodd" clip-rule="evenodd"
                    d="M25.091 8.86902C24.509 8.3126 23.7196 8 22.8966 8H20.6207C19.7976 8 19.0082 8.3126 18.4262 8.86902C17.8442 9.42545 17.5172 10.1801 17.5172 10.967V13.5385C17.5172 14.3254 17.8442 15.08 18.4262 15.6365C19.0082 16.1929 19.7976 16.5055 20.6207 16.5055H22.8966C23.7196 16.5055 24.509 16.1929 25.091 15.6365C25.673 15.08 26 14.3254 26 13.5385V10.967C26 10.1801 25.673 9.42545 25.091 8.86902ZM18.7586 13.5385V10.967C18.7586 10.4949 18.9548 10.0421 19.304 9.70823C19.6532 9.37437 20.1268 9.18681 20.6207 9.18681H22.8966C23.3904 9.18681 23.864 9.37437 24.2132 9.70823C24.5624 10.0421 24.7586 10.4949 24.7586 10.967V13.5385C24.7586 14.0106 24.5624 14.4634 24.2132 14.7973C23.864 15.1311 23.3904 15.3187 22.8966 15.3187H20.6207C20.1268 15.3187 19.6532 15.1311 19.304 14.7973C18.9548 14.4634 18.7586 14.0106 18.7586 13.5385Z"
                    fill="#2A3F57"/>
              <path fill-rule="evenodd" clip-rule="evenodd"
                    d="M15.5738 18.3635C14.9918 17.8071 14.2024 17.4945 13.3793 17.4945H11.1034C10.2804 17.4945 9.49099 17.8071 8.90898 18.3635C8.32697 18.92 8 19.6746 8 20.4615V23.033C8 23.8199 8.32697 24.5745 8.90898 25.131C9.49099 25.6874 10.2804 26 11.1034 26H13.3793C14.2024 26 14.9918 25.6874 15.5738 25.131C16.1558 24.5745 16.4828 23.8199 16.4828 23.033V20.4615C16.4828 19.6746 16.1558 18.92 15.5738 18.3635ZM9.24138 23.033V20.4615C9.24138 19.9894 9.43756 19.5366 9.78677 19.2027C10.136 18.8689 10.6096 18.6813 11.1034 18.6813H13.3793C13.8732 18.6813 14.3468 18.8689 14.696 19.2027C15.0452 19.5366 15.2414 19.9894 15.2414 20.4615V23.033C15.2414 23.5051 15.0452 23.9579 14.696 24.2918C14.3468 24.6256 13.8732 24.8132 13.3793 24.8132H11.1034C10.6096 24.8132 10.136 24.6256 9.78677 24.2918C9.43756 23.9579 9.24138 23.5051 9.24138 23.033Z"
                    fill="#2A3F57"/>
              <path fill-rule="evenodd" clip-rule="evenodd"
                    d="M25.091 18.3635C24.509 17.8071 23.7196 17.4945 22.8966 17.4945H20.6207C19.7976 17.4945 19.0082 17.8071 18.4262 18.3635C17.8442 18.92 17.5172 19.6746 17.5172 20.4615V23.033C17.5172 23.8199 17.8442 24.5745 18.4262 25.131C19.0082 25.6874 19.7976 26 20.6207 26H22.8966C23.7196 26 24.509 25.6874 25.091 25.131C25.673 24.5745 26 23.8199 26 23.033V20.4615C26 19.6746 25.673 18.92 25.091 18.3635ZM18.7586 23.033V20.4615C18.7586 19.9894 18.9548 19.5366 19.304 19.2027C19.6532 18.8689 20.1268 18.6813 20.6207 18.6813H22.8966C23.3904 18.6813 23.864 18.8689 24.2132 19.2027C24.5624 19.5366 24.7586 19.9894 24.7586 20.4615V23.033C24.7586 23.5051 24.5624 23.9579 24.2132 24.2918C23.864 24.6256 23.3904 24.8132 22.8966 24.8132H20.6207C20.1268 24.8132 19.6532 24.6256 19.304 24.2918C18.9548 23.9579 18.7586 23.5051 18.7586 23.033Z"
                    fill="#2A3F57"/>
              <rect x="0.5" y="0.5" width="33" height="33" rx="4.5" stroke="#2A3F57"/>
            </svg>
          </div>
          <div class="type-switcher__item type-switcher__item--settings" @click="settingsModal=true">
            <svg width="24" height="24" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
              <mask id="path-1-inside-1_1733_6915" fill="white">
                <path
                  d="M2.29162 8.85988C2.73501 7.49078 3.4634 6.23113 4.42882 5.16388C4.50861 5.0757 4.61281 5.01322 4.72819 4.98437C4.84356 4.95553 4.96491 4.96162 5.07682 5.00188L7.37842 5.82508C7.54227 5.88359 7.71688 5.90577 7.89016 5.89008C8.06343 5.8744 8.23122 5.82122 8.3819 5.73423C8.53258 5.64725 8.66254 5.52854 8.76278 5.38634C8.86302 5.24413 8.93114 5.08183 8.96242 4.91068L9.40042 2.50348C9.42163 2.3863 9.47723 2.27808 9.56014 2.1926C9.64306 2.10712 9.74953 2.04825 9.86602 2.02348C11.2722 1.72394 12.7258 1.72394 14.132 2.02348C14.2485 2.04825 14.355 2.10712 14.4379 2.1926C14.5208 2.27808 14.5764 2.3863 14.5976 2.50348L15.0368 4.91068C15.0681 5.08183 15.1362 5.24413 15.2364 5.38634C15.3367 5.52854 15.4666 5.64725 15.6173 5.73423C15.768 5.82122 15.9358 5.8744 16.1091 5.89008C16.2823 5.90577 16.457 5.88359 16.6208 5.82508L18.9236 5.00188C19.0355 4.96202 19.1566 4.95626 19.2718 4.98531C19.3869 5.01436 19.4909 5.07693 19.5704 5.16508C20.5353 6.23209 21.2632 7.4913 21.7064 8.85988C21.743 8.97293 21.7452 9.09429 21.7127 9.20858C21.6802 9.32288 21.6146 9.42495 21.524 9.50188L19.658 11.0859C19.5255 11.1985 19.419 11.3387 19.346 11.4965C19.2729 11.6544 19.2351 11.8263 19.2351 12.0003C19.2351 12.1742 19.2729 12.3461 19.346 12.504C19.419 12.6619 19.5255 12.802 19.658 12.9147L21.524 14.4987C21.6146 14.5756 21.6802 14.6777 21.7127 14.792C21.7452 14.9063 21.743 15.0276 21.7064 15.1407C21.2634 16.5097 20.5354 17.7693 19.5704 18.8367C19.4906 18.9249 19.3864 18.9873 19.271 19.0162C19.1557 19.045 19.0343 19.0389 18.9224 18.9987L16.6208 18.1755C16.457 18.117 16.2823 18.0948 16.1091 18.1105C15.9358 18.1262 15.768 18.1793 15.6173 18.2663C15.4666 18.3533 15.3367 18.472 15.2364 18.6142C15.1362 18.7564 15.0681 18.9187 15.0368 19.0899L14.5964 21.4983C14.5751 21.6151 14.5195 21.7229 14.4369 21.8082C14.3542 21.8934 14.2481 21.9522 14.132 21.9771C12.7258 22.2767 11.2722 22.2767 9.86602 21.9771C9.74953 21.9523 9.64306 21.8934 9.56014 21.808C9.47723 21.7225 9.42163 21.6143 9.40042 21.4971L8.96242 19.0899C8.93114 18.9187 8.86302 18.7564 8.76278 18.6142C8.66254 18.472 8.53258 18.3533 8.3819 18.2663C8.23122 18.1793 8.06343 18.1262 7.89016 18.1105C7.71688 18.0948 7.54227 18.117 7.37842 18.1755L5.07562 18.9987C4.96376 19.0385 4.84258 19.0443 4.72744 19.0152C4.61231 18.9862 4.50838 18.9236 4.42882 18.8355C3.46395 17.7685 2.73598 16.5093 2.29282 15.1407C2.25623 15.0276 2.25404 14.9063 2.28651 14.792C2.31899 14.6777 2.38466 14.5756 2.47522 14.4987L4.34122 12.9147C4.47377 12.802 4.58025 12.6619 4.65328 12.504C4.7263 12.3461 4.76412 12.1742 4.76412 12.0003C4.76412 11.8263 4.7263 11.6544 4.65328 11.4965C4.58025 11.3387 4.47377 11.1985 4.34122 11.0859L2.47522 9.50188C2.38466 9.42495 2.31899 9.32288 2.28651 9.20858C2.25404 9.09429 2.25623 8.97293 2.29282 8.85988H2.29162ZM3.56482 8.85268L5.11761 10.1703C5.38314 10.3956 5.59646 10.676 5.74276 10.992C5.88906 11.308 5.96484 11.652 5.96484 12.0003C5.96484 12.3485 5.88906 12.6926 5.74276 13.0086C5.59646 13.3246 5.38314 13.605 5.11761 13.8303L3.56482 15.1479C3.91522 16.0863 4.42162 16.9599 5.05882 17.7303L6.97401 17.0463C7.3018 16.9293 7.65112 16.8849 7.99774 16.9164C8.34436 16.9478 8.68 17.0543 8.98137 17.2284C9.28275 17.4025 9.54266 17.64 9.74307 17.9246C9.94349 18.2091 10.0796 18.5339 10.142 18.8763L10.508 20.8779C11.4952 21.0425 12.5028 21.0425 13.49 20.8779L13.856 18.8739C13.9186 18.5316 14.0548 18.207 14.2553 17.9226C14.4558 17.6382 14.7157 17.4007 15.017 17.2268C15.3184 17.0528 15.654 16.9464 16.0005 16.9151C16.3471 16.8837 16.6963 16.9281 17.024 17.0451L18.9404 17.7303C19.5788 16.9587 20.0837 16.0859 20.4344 15.1479L18.8816 13.8303C18.6157 13.6052 18.4021 13.3249 18.2555 13.0089C18.109 12.6928 18.0331 12.3486 18.0331 12.0003C18.0331 11.6519 18.109 11.3077 18.2555 10.9917C18.4021 10.6757 18.6157 10.3954 18.8816 10.1703L20.4344 8.85268C20.0838 7.91466 19.5788 7.04184 18.9404 6.27028L17.0252 6.95428C16.6975 7.0713 16.3483 7.11566 16.0017 7.08428C15.6552 7.05291 15.3196 6.94656 15.0182 6.77259C14.7169 6.59862 14.457 6.36121 14.2565 6.0768C14.056 5.79238 13.9198 5.46778 13.8572 5.12548L13.49 3.12268C12.5028 2.95809 11.4952 2.95809 10.508 3.12268L10.1432 5.12548C10.0808 5.46789 9.94469 5.79262 9.74427 6.07718C9.54386 6.36173 9.28395 6.59928 8.98257 6.77338C8.6812 6.94747 8.34556 7.05393 7.99894 7.08537C7.65232 7.11682 7.303 7.07249 6.97522 6.95548L5.05882 6.27028C4.42045 7.04185 3.9155 7.91467 3.56482 8.85268ZM8.99962 12.0003C8.99962 11.2046 9.31569 10.4416 9.87829 9.87896C10.4409 9.31635 11.204 9.00028 11.9996 9.00028C12.7953 9.00028 13.5583 9.31635 14.1209 9.87896C14.6835 10.4416 14.9996 11.2046 14.9996 12.0003C14.9996 12.7959 14.6835 13.559 14.1209 14.1216C13.5583 14.6842 12.7953 15.0003 11.9996 15.0003C11.204 15.0003 10.4409 14.6842 9.87829 14.1216C9.31569 13.559 8.99962 12.7959 8.99962 12.0003ZM10.1996 12.0003C10.1996 12.4777 10.3893 12.9355 10.7268 13.2731C11.0644 13.6106 11.5222 13.8003 11.9996 13.8003C12.477 13.8003 12.9348 13.6106 13.2724 13.2731C13.61 12.9355 13.7996 12.4777 13.7996 12.0003C13.7996 11.5229 13.61 11.0651 13.2724 10.7275C12.9348 10.3899 12.477 10.2003 11.9996 10.2003C11.5222 10.2003 11.0644 10.3899 10.7268 10.7275C10.3893 11.0651 10.1996 11.5229 10.1996 12.0003Z"/>
              </mask>
              <path
                d="M2.29162 8.85988C2.73501 7.49078 3.4634 6.23113 4.42882 5.16388C4.50861 5.0757 4.61281 5.01322 4.72819 4.98437C4.84356 4.95553 4.96491 4.96162 5.07682 5.00188L7.37842 5.82508C7.54227 5.88359 7.71688 5.90577 7.89016 5.89008C8.06343 5.8744 8.23122 5.82122 8.3819 5.73423C8.53258 5.64725 8.66254 5.52854 8.76278 5.38634C8.86302 5.24413 8.93114 5.08183 8.96242 4.91068L9.40042 2.50348C9.42163 2.3863 9.47723 2.27808 9.56014 2.1926C9.64306 2.10712 9.74953 2.04825 9.86602 2.02348C11.2722 1.72394 12.7258 1.72394 14.132 2.02348C14.2485 2.04825 14.355 2.10712 14.4379 2.1926C14.5208 2.27808 14.5764 2.3863 14.5976 2.50348L15.0368 4.91068C15.0681 5.08183 15.1362 5.24413 15.2364 5.38634C15.3367 5.52854 15.4666 5.64725 15.6173 5.73423C15.768 5.82122 15.9358 5.8744 16.1091 5.89008C16.2823 5.90577 16.457 5.88359 16.6208 5.82508L18.9236 5.00188C19.0355 4.96202 19.1566 4.95626 19.2718 4.98531C19.3869 5.01436 19.4909 5.07693 19.5704 5.16508C20.5353 6.23209 21.2632 7.4913 21.7064 8.85988C21.743 8.97293 21.7452 9.09429 21.7127 9.20858C21.6802 9.32288 21.6146 9.42495 21.524 9.50188L19.658 11.0859C19.5255 11.1985 19.419 11.3387 19.346 11.4965C19.2729 11.6544 19.2351 11.8263 19.2351 12.0003C19.2351 12.1742 19.2729 12.3461 19.346 12.504C19.419 12.6619 19.5255 12.802 19.658 12.9147L21.524 14.4987C21.6146 14.5756 21.6802 14.6777 21.7127 14.792C21.7452 14.9063 21.743 15.0276 21.7064 15.1407C21.2634 16.5097 20.5354 17.7693 19.5704 18.8367C19.4906 18.9249 19.3864 18.9873 19.271 19.0162C19.1557 19.045 19.0343 19.0389 18.9224 18.9987L16.6208 18.1755C16.457 18.117 16.2823 18.0948 16.1091 18.1105C15.9358 18.1262 15.768 18.1793 15.6173 18.2663C15.4666 18.3533 15.3367 18.472 15.2364 18.6142C15.1362 18.7564 15.0681 18.9187 15.0368 19.0899L14.5964 21.4983C14.5751 21.6151 14.5195 21.7229 14.4369 21.8082C14.3542 21.8934 14.2481 21.9522 14.132 21.9771C12.7258 22.2767 11.2722 22.2767 9.86602 21.9771C9.74953 21.9523 9.64306 21.8934 9.56014 21.808C9.47723 21.7225 9.42163 21.6143 9.40042 21.4971L8.96242 19.0899C8.93114 18.9187 8.86302 18.7564 8.76278 18.6142C8.66254 18.472 8.53258 18.3533 8.3819 18.2663C8.23122 18.1793 8.06343 18.1262 7.89016 18.1105C7.71688 18.0948 7.54227 18.117 7.37842 18.1755L5.07562 18.9987C4.96376 19.0385 4.84258 19.0443 4.72744 19.0152C4.61231 18.9862 4.50838 18.9236 4.42882 18.8355C3.46395 17.7685 2.73598 16.5093 2.29282 15.1407C2.25623 15.0276 2.25404 14.9063 2.28651 14.792C2.31899 14.6777 2.38466 14.5756 2.47522 14.4987L4.34122 12.9147C4.47377 12.802 4.58025 12.6619 4.65328 12.504C4.7263 12.3461 4.76412 12.1742 4.76412 12.0003C4.76412 11.8263 4.7263 11.6544 4.65328 11.4965C4.58025 11.3387 4.47377 11.1985 4.34122 11.0859L2.47522 9.50188C2.38466 9.42495 2.31899 9.32288 2.28651 9.20858C2.25404 9.09429 2.25623 8.97293 2.29282 8.85988H2.29162ZM3.56482 8.85268L5.11761 10.1703C5.38314 10.3956 5.59646 10.676 5.74276 10.992C5.88906 11.308 5.96484 11.652 5.96484 12.0003C5.96484 12.3485 5.88906 12.6926 5.74276 13.0086C5.59646 13.3246 5.38314 13.605 5.11761 13.8303L3.56482 15.1479C3.91522 16.0863 4.42162 16.9599 5.05882 17.7303L6.97401 17.0463C7.3018 16.9293 7.65112 16.8849 7.99774 16.9164C8.34436 16.9478 8.68 17.0543 8.98137 17.2284C9.28275 17.4025 9.54266 17.64 9.74307 17.9246C9.94349 18.2091 10.0796 18.5339 10.142 18.8763L10.508 20.8779C11.4952 21.0425 12.5028 21.0425 13.49 20.8779L13.856 18.8739C13.9186 18.5316 14.0548 18.207 14.2553 17.9226C14.4558 17.6382 14.7157 17.4007 15.017 17.2268C15.3184 17.0528 15.654 16.9464 16.0005 16.9151C16.3471 16.8837 16.6963 16.9281 17.024 17.0451L18.9404 17.7303C19.5788 16.9587 20.0837 16.0859 20.4344 15.1479L18.8816 13.8303C18.6157 13.6052 18.4021 13.3249 18.2555 13.0089C18.109 12.6928 18.0331 12.3486 18.0331 12.0003C18.0331 11.6519 18.109 11.3077 18.2555 10.9917C18.4021 10.6757 18.6157 10.3954 18.8816 10.1703L20.4344 8.85268C20.0838 7.91466 19.5788 7.04184 18.9404 6.27028L17.0252 6.95428C16.6975 7.0713 16.3483 7.11566 16.0017 7.08428C15.6552 7.05291 15.3196 6.94656 15.0182 6.77259C14.7169 6.59862 14.457 6.36121 14.2565 6.0768C14.056 5.79238 13.9198 5.46778 13.8572 5.12548L13.49 3.12268C12.5028 2.95809 11.4952 2.95809 10.508 3.12268L10.1432 5.12548C10.0808 5.46789 9.94469 5.79262 9.74427 6.07718C9.54386 6.36173 9.28395 6.59928 8.98257 6.77338C8.6812 6.94747 8.34556 7.05393 7.99894 7.08537C7.65232 7.11682 7.303 7.07249 6.97522 6.95548L5.05882 6.27028C4.42045 7.04185 3.9155 7.91467 3.56482 8.85268ZM8.99962 12.0003C8.99962 11.2046 9.31569 10.4416 9.87829 9.87896C10.4409 9.31635 11.204 9.00028 11.9996 9.00028C12.7953 9.00028 13.5583 9.31635 14.1209 9.87896C14.6835 10.4416 14.9996 11.2046 14.9996 12.0003C14.9996 12.7959 14.6835 13.559 14.1209 14.1216C13.5583 14.6842 12.7953 15.0003 11.9996 15.0003C11.204 15.0003 10.4409 14.6842 9.87829 14.1216C9.31569 13.559 8.99962 12.7959 8.99962 12.0003ZM10.1996 12.0003C10.1996 12.4777 10.3893 12.9355 10.7268 13.2731C11.0644 13.6106 11.5222 13.8003 11.9996 13.8003C12.477 13.8003 12.9348 13.6106 13.2724 13.2731C13.61 12.9355 13.7996 12.4777 13.7996 12.0003C13.7996 11.5229 13.61 11.0651 13.2724 10.7275C12.9348 10.3899 12.477 10.2003 11.9996 10.2003C11.5222 10.2003 11.0644 10.3899 10.7268 10.7275C10.3893 11.0651 10.1996 11.5229 10.1996 12.0003Z"
                fill="#E1EBF8" stroke="#E1EBF8" stroke-width="2" mask="url(#path-1-inside-1_1733_6915)"/>
            </svg>
          </div>
        </div>
      </div>
    </div>
    <div class="page-head" v-if="!inviteMode">
      <div class="page__sorts align-baseline">
        <v-menu ref="date" v-model="menuDate"
                :close-on-content-click="false" transition="scale-transition">
          <template v-slot:activator="{ on, attrs }">
            <v-text-field class="search-field" :value="range.join(' ~ ')"
                          @keypress.enter="loadData()" prepend-inner-icon="$calendar"
                          :placeholder="$vuetify.lang.t('$vuetify.dateTimings')" outlined
                          hide-details v-bind="attrs" v-on="on" readonly clearable
                          @click:clear="range=[]; loadData()">
            </v-text-field>
          </template>
          <v-date-picker v-model="range" no-title first-day-of-week="1" show-week locale-first-day-of-year="4"
                         show-adjacent-months
                         range @input="range.length == 2  ? menuDate = false : menuDate = true"
          ></v-date-picker>
        </v-menu>
        <v-checkbox v-model="with_arch"
                    :label="$vuetify.lang.t('$vuetify.withArch')"></v-checkbox>
        <v-checkbox v-model="future"
                    :label="$vuetify.lang.t('$vuetify.futureObjects')"></v-checkbox>
      </div>
    </div>
    <table class="main-table" v-if="!inviteMode">
      <thead v-if="type == 'rows'">
      <draggable v-model="headers" tag="tr" @change="saveSettings">
        <template v-for="header in headers">
          <td class="sortable" @click="set_sort(header.key)" :key="header.key" scope="col"
              v-if="showHeaders[header.key]">
            {{ $vuetify.lang.t('$vuetify.' + header.name) }}
            <v-icon class="sorts__icon" v-if="sort.includes(header.key)" :class="{reverse: sort[0] == '-'}">
              mdi-arrow-up
            </v-icon>
          </td>
        </template>
      </draggable>
      </thead>
      <tbody :class="{ 'cards ': type == 'cards' }">
      <object-card v-for="(object) in objects" :key="object.id" :id="object.id" :photo="object.photo"
                   :options="object.options" :type="type" :active="object.active" :client="object.client"
                   :unread="object.unread" :address="object.address"
                   :headers="headers"
                   @edit="
            (id) => {
              object_action = 'edit';
              chosen_id = id;
              object_create_open();
            }
          "
                   @archive="() => {loadData()}"
                   @copy="(id) => {
              object_action = 'copy';
              chosen_id = id;
              object_create_open();
            }"
      ></object-card>
      </tbody>
    </table>
    <table class="main-table" v-if="inviteMode">
      <thead>
      <td> {{ $vuetify.lang.t('$vuetify.name2') }}</td>
      <td> {{ $vuetify.lang.t('$vuetify.address') }}</td>
      <td> {{ $vuetify.lang.t('$vuetify.from') }}</td>
      <td> {{ $vuetify.lang.t('$vuetify.date') }}</td>
      <td></td>
      </thead>
      <tbody>
      <tr class="man-wrap rows__single align-center" v-for="invite in invitations" :key="invite.id">
        <td class="flex">
          <div class="avatar">
            <img v-if="photo" :src="$media_url + invite.object.photo_path" loading="lazy" alt=""/>
          </div>
          {{ invite.object.name }}
        </td>
        <td>
          <a target="_blank"
             :href="'https://www.google.com/maps/search/?api=1&query='+invite.object.street + '+' + invite.object.house + '+' + invite.object.city">
            {{
              invite.object.street + ' ' + invite.object.house + (invite.object.entrance ? (' ' + invite.object.entrance + ' ') : '') + (invite.object.flat ? (' ' + invite.object.flat + ', ') : ', ') + invite.object.index + ' ' + invite.object.city + ', ' + invite.object.country
            }}
          </a>
        </td>
        <td>{{ invite.from_organization.name }}</td>
        <td>{{ new Date(invite.create_date).toLocaleDateString() }}</td>
        <td class="flex flex-nowrap">
          <button class="btn-secondary btn" @click="acceptInvitation(invite.id)">
            <span>{{ $vuetify.lang.t('$vuetify.accept') }}</span>
          </button>
          <button class="btn-secondary btn" @click="rejectInvitation(invite.id)">
            <span>{{ $vuetify.lang.t('$vuetify.reject') }}</span>
          </button>
        </td>
      </tr>
      </tbody>
    </table>
    <div class="page-footer">
      <per-page-select v-model="perPage"></per-page-select>
      <v-pagination
        v-model="page"
        :length="length"
        @input="loadData"
      ></v-pagination>
    </div>

    <v-dialog v-model="object_create_modal">
      <div class="modal modal-big">
        <div class="h1">
          <span v-if="object_action == 'add'">{{ $vuetify.lang.t('$vuetify.addObject') }}</span><span
          v-if="object_action == 'edit'">{{ $vuetify.lang.t('$vuetify.editObject') }}</span>
        </div>
        <v-form ref="form" v-if="object_create_step == 1" @submit.prevent="">
          <div class="h2">{{ $vuetify.lang.t('$vuetify.accounting.card.client') }}</div>
          <v-autocomplete v-model="newObject.org_client" class="custom" :label="$vuetify.lang.t('$vuetify.partners')"
                          :items="organizations" item-text="name" item-value="id" outlined attach
                          :disabled="newObject.client_id != undefined" clearable
                          :menu-props="{
              bottom: true,
              offsetY: true,
              axHeight: width<1024 ? 300 : 800,
              contentClass: 'select-menu',
            }">
          </v-autocomplete>
          <v-autocomplete v-model="newObject.client_id" class="custom" :label="$vuetify.lang.t('$vuetify.fromNotes')"
                          :items="clients" item-text="name" item-value="id" outlined attach
                          :disabled="newObject.org_client!= undefined" clearable
                          :menu-props="{
              bottom: true,
              offsetY: true,
              axHeight: width<1024 ? 300 : 800,
              contentClass: 'select-menu',
            }"></v-autocomplete>
          <div class="h2">{{ $vuetify.lang.t('$vuetify.contractor') }}</div>
          <v-autocomplete v-model="newObject.organization" class="custom" :label="$vuetify.lang.t('$vuetify.partners')"
                          :items="organizations" item-text="name" item-value="id" outlined attach
                          multiple
                          :menu-props="{
              bottom: true,
              offsetY: true,
              axHeight: width<1024 ? 300 : 800,
              contentClass: 'select-menu',
            }">
          </v-autocomplete>
          <v-autocomplete v-model="newObject.clients" class="custom" :label="$vuetify.lang.t('$vuetify.fromNotes')"
                          :items="clients" item-text="name" item-value="id" outlined attach multiple
                          :menu-props="{
              bottom: true,
              offsetY: true,
              axHeight: width<1024 ? 300 : 800,
              contentClass: 'select-menu',
            }"></v-autocomplete>
          <v-checkbox v-if="permissions.admin" v-model="newObject.contacts_visible"
                      :label="$vuetify.lang.t('$vuetify.contactsVisible')"></v-checkbox>
          <div class="h2">{{ $vuetify.lang.t('$vuetify.address') }}</div>
          <div class="form__row form__address">
            <v-text-field v-model="newObject.street" class="address__street" :label="$vuetify.lang.t('$vuetify.street')"
                          outlined :rules="[$rules.required]"></v-text-field>
            <v-text-field v-model="newObject.house" class="address__house" :label="$vuetify.lang.t('$vuetify.house')"
                          outlined :rules="[$rules.required]"></v-text-field>
            <v-text-field v-model="newObject.entrance" class="address__entrance"
                          :label="$vuetify.lang.t('$vuetify.entrance')" outlined>
            </v-text-field>
            <v-text-field v-model="newObject.flat" class="address__flat" :label="$vuetify.lang.t('$vuetify.flat')"
                          outlined>
            </v-text-field>
          </div>
          <div class="form__row form__address">
            <v-text-field v-model="newObject.index" class="address__index" :label="$vuetify.lang.t('$vuetify.index')"
                          outlined :rules="[$rules.required]"></v-text-field>
            <v-text-field v-model="newObject.city" class="address__city" :label="$vuetify.lang.t('$vuetify.city')"
                          outlined :rules="[$rules.required]"></v-text-field>
          </div>
          <v-text-field v-model="newObject.country" class="address__country"
                        :label="$vuetify.lang.t('$vuetify.country')" outlined :rules="[$rules.required]"></v-text-field>

          <v-file-input class="file-input" v-model="photo" accept=".jpg, .png, .jpeg"
                        :placeholder="newObject.photo_path ? $vuetify.lang.t('$vuetify.changeImg') : $vuetify.lang.t('$vuetify.uploadImg')"
                        prepend-icon="$photo" :rules="[$rules.fileSize]"></v-file-input>
          <div class="sign-up__buttons btn-group">
            <button class="btn btn-secondary" @click="object_create_close">
              {{ $vuetify.lang.t('$vuetify.back') }}
            </button>
            <button class="btn btn-primary" @click="nextStep">{{ $vuetify.lang.t('$vuetify.forward') }}</button>
          </div>
        </v-form>
        <v-form ref="form" v-if="object_create_step == 2" @submit.prevent="">
          <div class="h2">{{ $vuetify.lang.t('$vuetify.aboutObject') }}</div>

          <v-text-field v-model="newObject.name" :label="$vuetify.lang.t('$vuetify.objectName')" outlined
                        :rules="[$rules.required]">
          </v-text-field>
          <div class="form__row">
            <v-menu ref="menuStart" v-model="menuStart" :close-on-content-click="false" transition="scale-transition">
              <template v-slot:activator="{ on, attrs }">
                <v-text-field
                  :value="newObject.date_start ? new Date(newObject.date_start).toLocaleDateString('ru-Ru') : ''"
                  :label="$vuetify.lang.t('$vuetify.worksStart')" append-icon="$calendar" v-bind="attrs"
                  v-on="on"
                  outlined :rules="[$rules.required]" readonly></v-text-field>
              </template>
              <v-date-picker v-model="newObject.date_start" @input="menuStart = false"
                             no-title first-day-of-week="1" show-week locale-first-day-of-year="4"
                             show-adjacent-months></v-date-picker>
            </v-menu>

            <v-menu ref="menuEnd" v-model="menuEnd" :close-on-content-click="false" transition="scale-transition">
              <template v-slot:activator="{ on, attrs }">
                <v-text-field clearable
                              :value="newObject.date_end ? new Date(newObject.date_end).toLocaleDateString('ru-Ru') : ''"
                              :label="$vuetify.lang.t('$vuetify.worksEnd')" append-icon="$calendar" v-bind="attrs"
                              v-on="on"
                              outlined readonly>
                </v-text-field>
              </template>
              <v-date-picker v-model="newObject.date_end" @input="menuEnd = false"
                             no-title first-day-of-week="1" show-week locale-first-day-of-year="4"
                             show-adjacent-months></v-date-picker>
            </v-menu>
          </div>
          <v-text-field v-model="newObject.square" type="number" pattern="[0-9]*[\.,]*[0-9]{0,3}"
                        :label="$vuetify.lang.t('$vuetify.square')" outlined
                        :suffix="$vuetify.lang.t('$vuetify.measurements.m2')"></v-text-field>
          <div class="form__row">
            <v-text-field v-model="newObject.accident_insurance"
                          :label="$vuetify.lang.t('$vuetify.accidentInsurance')"
                          outlined>
            </v-text-field>

            <v-text-field v-model="newObject.health_insurance" :label="$vuetify.lang.t('$vuetify.healthInsurance')"
                          outlined>
            </v-text-field>
          </div>
          <v-text-field v-model="newObject.habitation" :label="$vuetify.lang.t('$vuetify.habitation')" outlined>
          </v-text-field>

          <div class="sign-up__buttons btn-group">
            <button class="btn btn-secondary" @click="object_create_step--">
              {{ $vuetify.lang.t('$vuetify.back') }}
            </button>
            <button class="btn btn-primary" @click="nextStep">{{ $vuetify.lang.t('$vuetify.forward') }}</button>
          </div>
        </v-form>

        <v-form ref="form" v-if="object_create_step == 3" @submit.prevent="">
          <div class="h2">{{ $vuetify.lang.t('$vuetify.workList') }}</div>
          <div v-for="work in obj_works" :key="work">
            <div class="obj-work mb-20 justify-between">
              {{ work }}

              <div class="obj-works__close" @click="obj_works = obj_works.filter((value) => value != work)">
                <svg width="9" height="9" viewBox="0 0 9 9" fill="none" xmlns="http://www.w3.org/2000/svg">
                  <path d="M1 1L8 8M1 8L4.5 4.5L8 1" stroke="#6A9DDA" stroke-linecap="round" stroke-linejoin="round"/>
                </svg>
              </div>
            </div>
          </div>
          <div class="flex astart mb-20">
            <v-text-field :label="$vuetify.lang.t('$vuetify.enterWorkText')" outlined v-model="obj_work"
                          @keyup.enter="obj_work_add">
            </v-text-field>
            <button class="btn btn-secondary" @click="obj_work_add">
              {{ $vuetify.lang.t('$vuetify.addWork') }}
            </button>
          </div>

          <v-progress-linear :class="{form__progress : form_loader}"
                             :active="form_loader"
                             indeterminate
                             rounded
                             height="6"
          ></v-progress-linear>

          <div class="error--text" v-if="alertError">{{ alertMsg }}</div>
          <div class="sign-up__buttons btn-group">
            <button class="btn btn-secondary" @click="object_create_step--">
              {{ $vuetify.lang.t('$vuetify.back') }}
            </button>
            <button class="btn btn-primary" @click="uploadFile">
              <span v-if="object_action == 'add'">{{ $vuetify.lang.t('$vuetify.addObject') }}</span><span
              v-if="object_action == 'edit'">{{ $vuetify.lang.t('$vuetify.editObject') }}</span>
            </button>
          </div>
        </v-form>
      </div>
    </v-dialog>

    <SpinnerLoader :overlay="loader"></SpinnerLoader>

    <v-dialog v-model="settingsModal">
      <div class="modal">
        <div class="h1">
          {{ $vuetify.lang.t("$vuetify.selectShownHeaders") }}
        </div>
        <v-form ref="form" @submit.prevent="">
          <v-checkbox v-for="header in headers" v-model="showHeaders[header.key]" :key="header.key"
                      :label="$vuetify.lang.t('$vuetify.' + header.name)"></v-checkbox>
          <div class="error--text" v-if="alertError">{{ alertMsg }}</div>
          <div class="sign-up__buttons btn-group">
            <button class="btn btn-secondary" @click="settingsModal=false">
              {{ $vuetify.lang.t('$vuetify.cancel') }}
            </button>
            <button class="btn btn-primary" @click="saveSettings">
              {{ $vuetify.lang.t('$vuetify.save') }}
            </button>
          </div>
        </v-form>
      </div>
    </v-dialog>
  </div>
</template>
<script>
import ObjectCard from "./parts/ObjectCard.vue";
import SpinnerLoader from "@/components/SpinnerLoader";
import draggable from 'vuedraggable';
import PerPageSelect from "@/components/PerPageSelect.vue";
import {mapActions, mapGetters} from "vuex";

class Option {
  constructor(value, name = "unnamed", icon = "") {
    this.value = value;
    this.name = name;
    this.icon = icon;
  }
}

export default {
  name: "objects-list",
  components: {
    PerPageSelect,
    ObjectCard,
    SpinnerLoader,
    draggable,
  },

  data: function () {
    return {
      type: localStorage.getItem("type_objects") ?? (window.screen.width < 600 ? "cards" : "cards"),
      arch: false,
      inviteMode: false,
      page: 1,
      perPage: Number(localStorage.getItem("per_page") ?? 24),
      length: 0,
      sort: "-number",
      search: "",
      range: [],
      with_arch: false,
      future: false,
      filter: {
        client: ''
      },
      selectSorts: [
        {
          name: this.$vuetify.lang.t('$vuetify.sorts.byName') + " " + this.$vuetify.lang.t('$vuetify.sortAscending'),
          type: "byName",
          direction: "sortAscending",
          value: 'name'
        },
        {
          name: this.$vuetify.lang.t('$vuetify.sorts.byName') + " " + this.$vuetify.lang.t('$vuetify.sortDescending'),
          type: "byName",
          direction: "sortDescending",
          value: '-name'
        },
        {
          name: this.$vuetify.lang.t('$vuetify.sorts.byCreateDate') + " " + this.$vuetify.lang.t('$vuetify.sortAscending'),
          type: "byCreateDate",
          direction: "sortAscending",
          value: 'create_date'
        },
        {
          name: this.$vuetify.lang.t('$vuetify.sorts.byCreateDate') + " " + this.$vuetify.lang.t('$vuetify.sortDescending'),
          type: "byCreateDate",
          direction: "sortDescending",
          value: '-create_date'
        },
        {
          name: this.$vuetify.lang.t('$vuetify.sorts.byStartDate') + " " + this.$vuetify.lang.t('$vuetify.sortAscending'),
          type: "byStartDate",
          direction: "sortAscending",
          value: 'date_start'
        },
        {
          name: this.$vuetify.lang.t('$vuetify.sorts.byStartDate') + " " + this.$vuetify.lang.t('$vuetify.sortDescending'),
          type: "byStartDate",
          direction: "sortDescending",
          value: '-date_start'
        },
        {
          name: this.$vuetify.lang.t('$vuetify.sorts.byAddress') + " " + this.$vuetify.lang.t('$vuetify.sortAscending'),
          type: "byAddress",
          direction: "sortAscending",
          value: 'address'
        },
        {
          name: this.$vuetify.lang.t('$vuetify.sorts.byAddress') + " " + this.$vuetify.lang.t('$vuetify.sortDescending'),
          type: "byAddress",
          direction: "sortDescending",
          value: '-address'
        },
        {
          name: this.$vuetify.lang.t('$vuetify.sorts.byNumber') + " " + this.$vuetify.lang.t('$vuetify.sortAscending'),
          type: "byNumber",
          direction: "sortAscending",
          value: 'number'
        },
        {
          name: this.$vuetify.lang.t('$vuetify.sorts.byNumber') + " " + this.$vuetify.lang.t('$vuetify.sortDescending'),
          type: "byNumber",
          direction: "sortDescending",
          value: '-number'
        },
      ],
      headers: [
        {key: "name", name: 'name2'},
        {key: "number", name: 'number'},
        {key: "address", name: 'address'},
        {key: "client_id__name", name: 'client'},
      ],

      tmp: false,

      object_action: "add",

      newObject: {
        country: "Suomi",
        name: "",
        index: "",
        city: "",
        street: "",
        house: "",
        entrance: "",
        flat: "",
        date_start: "",
        date_end: "",
        active: false,
        client_id: "",
        org_client: null,
        habitation: null,
        accident_insurance: null,
        health_insurance: null,
        photo_path: null,
        contacts_visible: false,
      },
      object_create_modal: false,
      object_create_step: 1,
      chosen_id: 0,
      photo: null,

      obj_works: [],
      obj_work: "",

      objects: [],
      row_objects: [],
      clients: [],
      organizations: [],
      invitations: [],

      menuStart: false,
      menuEnd: false,
      menuDate: false,

      alertError: false,
      alertMsg: "",
      loader: false,
      form_loader: false,

      settingsModal: false,
      tableSettings: {},
      showHeaders: {},
      width: screen.width,
    };
  },

  created: function () {
    this.checkPermission('Объекты').then(() => {
      this.loadData();
      this.loadSettings();
      this.loadInvitations();
    })

    // if (this.checkPermission('Объекты')) {
    //   this.loadData();
    //   this.loadSettings();
    // }
  },

  methods: {
    ...mapActions(['checkPermission']),
    loadData: function () {
      this.loader = true
      let twoWeeksFromToday = new Date().setDate(new Date().getDate() + 14);
      twoWeeksFromToday = new Date(twoWeeksFromToday)
      const formattedDate = twoWeeksFromToday.toISOString().substring(0, 10);

      this.filter.date_start_min = this.future ? formattedDate : null
      this.filter.date_start_max = !this.future ? formattedDate : null
      this.$axios({
        url: this.$hostname + "time-tracking/objects",
        method: "get",
        headers: {
          Authorization:
            "Token " +
            (localStorage.getItem("auth_token") ||
              sessionStorage.getItem("auth_token")),
        },
        params: {
          arch: this.arch,
          sort: this.sort,
          search: this.search,
          range: JSON.stringify(this.range),
          with_arch: this.with_arch,
          filter: JSON.stringify(this.filter),
          page: this.page,
          per: this.perPage
        }
      }).then((response) => {
        this.objects = [];
        if (response.data.data.data) {
          this.length = response.data.data.pages
          this.row_objects = response.data.data.data;
          let unread = response.data.data.unread
          response.data.data.data.forEach((element) => {
            this.objects.push({
              id: element.id,
              photo: element.photo_path,
              active: element.active,
              client: element.client_id ? element.client_id.id : element.org_client ? element.org_client.id : '',
              unread: unread[element.id],
              address: element.street + '+' + element.house + '+' + element.city,
              options: {
                array: [
                  new Option(element.name),
                  new Option(
                    new Date(element.date_start).toLocaleDateString('ru-Ru') + (element.date_end ? ('~' + new Date(element.date_end).toLocaleDateString('ru-Ru')) : ""),
                  ),
                  new Option(
                    element.number,
                    "number",
                    '<svg width="16" height="20" viewBox="0 0 16 20" fill="none" xmlns="http://www.w3.org/2000/svg"><path d="M4.10078 5.80039C4.33948 5.80039 4.56839 5.70557 4.73718 5.53679C4.90596 5.368 5.00078 5.13909 5.00078 4.90039C5.00078 4.6617 4.90596 4.43278 4.73718 4.26399C4.56839 4.09521 4.33948 4.00039 4.10078 4.00039C3.86209 4.00039 3.63317 4.09521 3.46439 4.26399C3.2956 4.43278 3.20078 4.6617 3.20078 4.90039C3.20078 5.13909 3.2956 5.368 3.46439 5.53679C3.63317 5.70557 3.86209 5.80039 4.10078 5.80039Z" fill="#2C1521"/><path d="M5.00078 8.50039C5.00078 8.73909 4.90596 8.968 4.73718 9.13679C4.56839 9.30557 4.33948 9.40039 4.10078 9.40039C3.86209 9.40039 3.63317 9.30557 3.46439 9.13679C3.2956 8.968 3.20078 8.73909 3.20078 8.50039C3.20078 8.2617 3.2956 8.03278 3.46439 7.864C3.63317 7.69521 3.86209 7.60039 4.10078 7.60039C4.33948 7.60039 4.56839 7.69521 4.73718 7.864C4.90596 8.03278 5.00078 8.2617 5.00078 8.50039Z" fill="#2C1521"/><path d="M4.10078 13.0004C4.21897 13.0004 4.336 12.9771 4.4452 12.9319C4.55439 12.8867 4.6536 12.8204 4.73718 12.7368C4.82075 12.6532 4.88704 12.554 4.93227 12.4448C4.9775 12.3356 5.00078 12.2186 5.00078 12.1004C5.00078 11.9822 4.9775 11.8652 4.93227 11.756C4.88704 11.6468 4.82075 11.5476 4.73718 11.464C4.6536 11.3804 4.55439 11.3141 4.4452 11.2689C4.336 11.2237 4.21897 11.2004 4.10078 11.2004C3.86209 11.2004 3.63317 11.2952 3.46439 11.464C3.2956 11.6328 3.20078 11.8617 3.20078 12.1004C3.20078 12.3391 3.2956 12.568 3.46439 12.7368C3.63317 12.9056 3.86209 13.0004 4.10078 13.0004Z" fill="#2C1521"/><path d="M8.60078 4.90039C8.60078 5.13909 8.50596 5.368 8.33718 5.53679C8.16839 5.70557 7.93948 5.80039 7.70078 5.80039C7.46209 5.80039 7.23317 5.70557 7.06438 5.53679C6.8956 5.368 6.80078 5.13909 6.80078 4.90039C6.80078 4.6617 6.8956 4.43278 7.06438 4.26399C7.23317 4.09521 7.46209 4.00039 7.70078 4.00039C7.93948 4.00039 8.16839 4.09521 8.33718 4.26399C8.50596 4.43278 8.60078 4.6617 8.60078 4.90039Z" fill="#2C1521"/><path d="M7.70078 9.40039C7.93948 9.40039 8.16839 9.30557 8.33718 9.13679C8.50596 8.968 8.60078 8.73909 8.60078 8.50039C8.60078 8.2617 8.50596 8.03278 8.33718 7.864C8.16839 7.69521 7.93948 7.60039 7.70078 7.60039C7.46209 7.60039 7.23317 7.69521 7.06438 7.864C6.8956 8.03278 6.80078 8.2617 6.80078 8.50039C6.80078 8.73909 6.8956 8.968 7.06438 9.13679C7.23317 9.30557 7.46209 9.40039 7.70078 9.40039Z" fill="#2C1521"/><path d="M8.60078 12.1004C8.60078 12.3391 8.50596 12.568 8.33718 12.7368C8.16839 12.9056 7.93948 13.0004 7.70078 13.0004C7.46209 13.0004 7.23317 12.9056 7.06438 12.7368C6.8956 12.568 6.80078 12.3391 6.80078 12.1004C6.80078 11.8617 6.8956 11.6328 7.06438 11.464C7.23317 11.2952 7.46209 11.2004 7.70078 11.2004C7.93948 11.2004 8.16839 11.2952 8.33718 11.464C8.50596 11.6328 8.60078 11.8617 8.60078 12.1004Z" fill="#2C1521"/><path d="M11.3008 13.0004C11.419 13.0004 11.536 12.9771 11.6452 12.9319C11.7544 12.8867 11.8536 12.8204 11.9372 12.7368C12.0208 12.6532 12.087 12.554 12.1323 12.4448C12.1775 12.3356 12.2008 12.2186 12.2008 12.1004C12.2008 11.9822 12.1775 11.8652 12.1323 11.756C12.087 11.6468 12.0208 11.5476 11.9372 11.464C11.8536 11.3804 11.7544 11.3141 11.6452 11.2689C11.536 11.2237 11.419 11.2004 11.3008 11.2004C11.0621 11.2004 10.8332 11.2952 10.6644 11.464C10.4956 11.6328 10.4008 11.8617 10.4008 12.1004C10.4008 12.3391 10.4956 12.568 10.6644 12.7368C10.8332 12.9056 11.0621 13.0004 11.3008 13.0004Z" fill="#2C1521"/><path d="M1.40078 19.6004C1.24165 19.6004 1.08904 19.5372 0.976517 19.4247C0.863995 19.3121 0.800781 19.1595 0.800781 19.0004V2.20039C0.800781 1.723 0.990423 1.26516 1.32799 0.927598C1.66555 0.590033 2.12339 0.400391 2.60078 0.400391H9.80078C10.2782 0.400391 10.736 0.590033 11.0736 0.927598C11.4111 1.26516 11.6008 1.723 11.6008 2.20039V7.60039H13.4008C13.8782 7.60039 14.336 7.79003 14.6736 8.1276C15.0111 8.46516 15.2008 8.923 15.2008 9.40039V19.0004C15.2008 19.1595 15.1376 19.3121 15.025 19.4247C14.9125 19.5372 14.7599 19.6004 14.6008 19.6004H1.40078ZM2.00078 2.20039V18.4004H4.40078V15.4004C4.40078 15.2413 4.464 15.0886 4.57652 14.9761C4.68904 14.8636 4.84165 14.8004 5.00078 14.8004H11.0008C11.1599 14.8004 11.3125 14.8636 11.425 14.9761C11.5376 15.0886 11.6008 15.2413 11.6008 15.4004V18.4004H14.0008V9.40039C14.0008 9.24126 13.9376 9.08865 13.825 8.97613C13.7125 8.8636 13.5599 8.80039 13.4008 8.80039H11.0008C10.8417 8.80039 10.689 8.73718 10.5765 8.62465C10.464 8.51213 10.4008 8.35952 10.4008 8.20039V2.20039C10.4008 2.04126 10.3376 1.88865 10.225 1.77613C10.1125 1.6636 9.95991 1.60039 9.80078 1.60039H2.60078C2.44165 1.60039 2.28904 1.6636 2.17652 1.77613C2.064 1.88865 2.00078 2.04126 2.00078 2.20039ZM10.4008 16.0004H8.60078V18.4004H10.4008V16.0004ZM7.40078 16.0004H5.60078V18.4004H7.40078V16.0004Z" fill="#2C1521"/></svg>'
                  ),
                  new Option(
                    (element.street + ' ' + element.house + (element.entrance ? (' ' + element.entrance + ' ') : '') + (element.flat ? (' ' + element.flat + ', ') : ', ') + element.index + ' ' + element.city + ', ' + element.country),

                    "address",
                    '<svg width="18" height="19" viewBox="0 0 18 19" fill="none" xmlns="http://www.w3.org/2000/svg"><path d="M7.79721 0.865346C8.12759 0.568506 8.55606 0.404297 9.00021 0.404297C9.44436 0.404297 9.87283 0.568506 10.2032 0.865346L16.8032 6.79575C16.9909 6.9645 17.1409 7.17082 17.2437 7.40133C17.3464 7.63184 17.3996 7.88138 17.3996 8.13375V16.5997C17.3996 17.0771 17.21 17.535 16.8724 17.8725C16.5348 18.2101 16.077 18.3997 15.5996 18.3997H12.5996C12.1222 18.3997 11.6644 18.2101 11.3268 17.8725C10.9893 17.535 10.7996 17.0771 10.7996 16.5997V12.3997C10.7996 12.2406 10.7364 12.088 10.6239 11.9755C10.5114 11.863 10.3587 11.7997 10.1996 11.7997H7.79961C7.64048 11.7997 7.48787 11.863 7.37535 11.9755C7.26282 12.088 7.19961 12.2406 7.19961 12.3997V16.5997C7.19961 17.0771 7.00997 17.535 6.6724 17.8725C6.33484 18.2101 5.877 18.3997 5.39961 18.3997H2.39961C1.92222 18.3997 1.46438 18.2101 1.12682 17.8725C0.789252 17.535 0.599609 17.0771 0.599609 16.5997V8.13375C0.599609 7.62375 0.815609 7.13775 1.19721 6.79575L7.79721 0.865346V0.865346ZM9.40041 1.75815C9.29031 1.65931 9.14757 1.60464 8.99961 1.60464C8.85165 1.60464 8.70891 1.65931 8.59881 1.75815L1.99881 7.68855C1.93629 7.74467 1.88625 7.8133 1.85193 7.88999C1.81762 7.96668 1.79979 8.04973 1.79961 8.13375V16.5997C1.79961 16.7589 1.86282 16.9115 1.97535 17.024C2.08787 17.1365 2.24048 17.1997 2.39961 17.1997H5.39961C5.55874 17.1997 5.71135 17.1365 5.82387 17.024C5.9364 16.9115 5.99961 16.7589 5.99961 16.5997V12.3997C5.99961 11.9224 6.18925 11.4645 6.52682 11.127C6.86438 10.7894 7.32222 10.5997 7.79961 10.5997H10.1996C10.677 10.5997 11.1348 10.7894 11.4724 11.127C11.81 11.4645 11.9996 11.9224 11.9996 12.3997V16.5997C11.9996 16.7589 12.0628 16.9115 12.1753 17.024C12.2879 17.1365 12.4405 17.1997 12.5996 17.1997H15.5996C15.7587 17.1997 15.9114 17.1365 16.0239 17.024C16.1364 16.9115 16.1996 16.7589 16.1996 16.5997V8.13375C16.1994 8.04973 16.1816 7.96668 16.1473 7.88999C16.113 7.8133 16.0629 7.74467 16.0004 7.68855L9.40041 1.75815Z" fill="#2C1521"/></svg>'
                  ),
                  new Option(
                    element.client_id ? element.client_id.name : element.org_client ? element.org_client.name : '',
                    "client",
                    '<svg width="20" height="19" viewBox="0 0 20 19" fill="none" xmlns="http://www.w3.org/2000/svg"><path d="M11.2004 10.0004C11.8369 10.0004 12.4474 10.2532 12.8974 10.7033C13.3475 11.1534 13.6004 11.7639 13.6004 12.4004V14.2004C13.6004 16.6652 11.0948 18.4004 7.00039 18.4004C2.90599 18.4004 0.400391 16.6652 0.400391 14.2004V12.4004C0.400391 11.7639 0.653247 11.1534 1.10333 10.7033C1.55342 10.2532 2.16387 10.0004 2.80039 10.0004H11.2004ZM11.2004 11.2004H2.80039C2.48213 11.2004 2.17691 11.3268 1.95186 11.5519C1.72682 11.7769 1.60039 12.0821 1.60039 12.4004V14.2004C1.60039 15.8888 3.49519 17.2004 7.00039 17.2004C10.5056 17.2004 12.4004 15.8888 12.4004 14.2004V12.4004C12.4004 12.0821 12.274 11.7769 12.0489 11.5519C11.8239 11.3268 11.5186 11.2004 11.2004 11.2004ZM17.2004 10.0004C17.8369 10.0004 18.4474 10.2532 18.8974 10.7033C19.3475 11.1534 19.6004 11.7639 19.6004 12.4004V13.0004C19.6004 15.5072 17.7188 17.2004 14.2004 17.2004C14.0312 17.2004 13.8644 17.1968 13.7036 17.1884C13.9532 16.898 14.162 16.586 14.33 16.2512L14.4464 15.9956H14.4932C17.1716 15.9176 18.4004 14.7524 18.4004 13.0004V12.4004C18.4004 12.0821 18.274 11.7769 18.0489 11.5519C17.8239 11.3268 17.5186 11.2004 17.2004 11.2004H14.5952C14.4381 10.7577 14.196 10.3501 13.8824 10.0004H17.2004ZM7.00039 0.400391C7.55194 0.400391 8.09809 0.509027 8.60766 0.720097C9.11723 0.931166 9.58023 1.24054 9.97024 1.63054C10.3602 2.02055 10.6696 2.48355 10.8807 2.99312C11.0918 3.50269 11.2004 4.04884 11.2004 4.60039C11.2004 5.15194 11.0918 5.69809 10.8807 6.20766C10.6696 6.71723 10.3602 7.18023 9.97024 7.57024C9.58023 7.96025 9.11723 8.26962 8.60766 8.48069C8.09809 8.69176 7.55194 8.80039 7.00039 8.80039C5.88648 8.80039 4.81819 8.35789 4.03054 7.57024C3.24289 6.78259 2.80039 5.7143 2.80039 4.60039C2.80039 3.48648 3.24289 2.4182 4.03054 1.63054C4.81819 0.842889 5.88648 0.400391 7.00039 0.400391ZM15.4004 2.80039C16.196 2.80039 16.9591 3.11646 17.5217 3.67907C18.0843 4.24168 18.4004 5.00474 18.4004 5.80039C18.4004 6.59604 18.0843 7.3591 17.5217 7.92171C16.9591 8.48432 16.196 8.80039 15.4004 8.80039C14.6047 8.80039 13.8417 8.48432 13.2791 7.92171C12.7165 7.3591 12.4004 6.59604 12.4004 5.80039C12.4004 5.00474 12.7165 4.24168 13.2791 3.67907C13.8417 3.11646 14.6047 2.80039 15.4004 2.80039ZM7.00039 1.60039C6.20474 1.60039 5.44168 1.91646 4.87907 2.47907C4.31646 3.04168 4.00039 3.80474 4.00039 4.60039C4.00039 5.39604 4.31646 6.1591 4.87907 6.72171C5.44168 7.28432 6.20474 7.60039 7.00039 7.60039C7.79604 7.60039 8.5591 7.28432 9.12171 6.72171C9.68432 6.1591 10.0004 5.39604 10.0004 4.60039C10.0004 3.80474 9.68432 3.04168 9.12171 2.47907C8.5591 1.91646 7.79604 1.60039 7.00039 1.60039ZM15.4004 4.00039C14.923 4.00039 14.4652 4.19003 14.1276 4.5276C13.79 4.86516 13.6004 5.323 13.6004 5.80039C13.6004 6.27778 13.79 6.73562 14.1276 7.07318C14.4652 7.41075 14.923 7.60039 15.4004 7.60039C15.8778 7.60039 16.3356 7.41075 16.6732 7.07318C17.0107 6.73562 17.2004 6.27778 17.2004 5.80039C17.2004 5.323 17.0107 4.86516 16.6732 4.5276C16.3356 4.19003 15.8778 4.00039 15.4004 4.00039Z" fill="#2C1521"/></svg>'
                  ),
                ],
                name: element.name,
                number: element.number,
                address: element.street + ' ' + element.house + (element.entrance ? (' ' + element.entrance + ' ') : '') + (element.flat ? (' ' + element.flat + ', ') : ', ') + element.index + ' ' + element.city + ', ' + element.country,
                client_id__name: element.client_id ? element.client_id.name : element.org_client ? element.org_client.name : '',
              }
            });
          });
        }
        if (this.permissions.edit.indexOf("Объекты") != -1)
          this.loadClients();
      }).catch((err) => {
        this.alertMsg = this.$catch(err);
        this.alertError = true;
      }).then(() => {
        this.loader = false
      })
    },
    loadClients() {
      this.$axios({
        url: this.$hostname + "time-tracking/clients",
        method: "GET",
        headers: {
          Authorization:
            "Token " +
            (localStorage.getItem("auth_token") ||
              sessionStorage.getItem("auth_token")),
        },
        params: {
          arch: !false,
        }
      })
        .then((response) => {
          this.clients = response.data.data.data;
          this.organizations = response.data.data.partners;
        })
        .catch((response) => {
          this.alertMsg = this.$catch(response);
          this.alertError = true;
        });
    },
    loadSettings() {
      this.$axios({
        url: this.$hostname + "time-tracking/user-settings/table-settings",
        method: "GET",
        headers: {
          Authorization:
            "Token " +
            (localStorage.getItem("auth_token") ||
              sessionStorage.getItem("auth_token")),
        },
      }).then((response) => {
        this.tableSettings = response.data.data.data
        if (response.data.data.data && response.data.data.data.objects) {
          this.showHeaders = response.data.data.data.objects
        } else
          this.showHeaders = {
            name: true,
            number: true,
            address: true,
            client_id__name: true
          }

        let order = []
        this.headers.forEach(header => {
          order.splice(this.showHeaders.order.indexOf(header.key), 0, header)
        })
        this.headers = order
      }).catch((response) => {
        this.alertMsg = this.$catch(response)
        this.alertError = true
      })
    },
    loadInvitations() {
      this.$axios({
        url: this.$hostname + "time-tracking/invitations",
        method: "GET",
        headers: {
          Authorization:
            "Token " +
            (localStorage.getItem("auth_token") ||
              sessionStorage.getItem("auth_token")),
        },
      }).then((response) => {
        this.invitations = response.data.data.data;
        if (this.inviteMode && this.invitations.length === 0) {
          this.inviteMode = false
        }
      }).catch((response) => {
        this.alertMsg = this.$catch(response);
        this.alertError = true;
      });
    },

    confirm_object() {
      this.form_loader = true
      if (this.object_action == "add") {
        this.add_object();
      } else if (this.object_action == "edit") {
        this.edit_object();
      }
    },
    add_object() {
      if (this.$refs.form.validate()) {
        this.$axios({
          url: this.$hostname + "time-tracking/objects",
          method: "POST",
          headers: {
            Authorization:
              "Token " +
              (localStorage.getItem("auth_token") ||
                sessionStorage.getItem("auth_token")),
            "Content-Type": "multipart/form-data",
          },
          data: {
            name: this.newObject.name,
            number: this.newObject.number,
            index: this.newObject.index,
            country: this.newObject.country,
            city: this.newObject.city,
            street: this.newObject.street,
            house: this.newObject.house,
            entrance: this.newObject.entrance,
            flat: this.newObject.flat,
            date_start: this.newObject.date_start,
            date_end: this.newObject.date_end,
            active: this.newObject.active,
            client_id: this.newObject.client_id,
            org_client: this.newObject.org_client,
            work_description: JSON.stringify(this.obj_works),
            habitation: this.newObject.habitation,
            square: this.newObject.square,
            accident_insurance: this.newObject.accident_insurance,
            health_insurance: this.newObject.health_insurance,
            photo_path: this.newObject.photo_path,
            clients: JSON.stringify(this.newObject.clients),
            partners: JSON.stringify(this.newObject.organization),
          },
        }).then(() => {
          this.loadData();
          this.object_create_close();
        }).catch((response) => {
          this.alertMsg = this.$catch(response);
          this.alertError = true;
        }).then(() => {
          this.form_loader = false
        })
      } else {
        this.alertMsg = "Заполните все необходимые данные";
        this.alertError = true;
        this.form_loader = false
      }
    },
    edit_object() {
      if (this.$refs.form.validate()) {
        this.$axios({
          url: this.$hostname + "time-tracking/objects",
          method: "PUT",
          headers: {
            Authorization:
              "Token " +
              (localStorage.getItem("auth_token") ||
                sessionStorage.getItem("auth_token")),
            "Content-Type": "multipart/form-data",
          },
          data: {
            id: this.newObject.id,
            name: this.newObject.name,
            number: this.newObject.number,
            index: this.newObject.index,
            country: this.newObject.country,
            city: this.newObject.city,
            street: this.newObject.street,
            house: this.newObject.house,
            entrance: this.newObject.entrance,
            flat: this.newObject.flat,
            date_start: this.newObject.date_start,
            date_end: this.newObject.date_end,
            active: this.newObject.active,
            client_id: this.newObject.client_id,
            org_client: this.newObject.org_client,
            work_description: JSON.stringify(this.obj_works),
            habitation: this.newObject.habitation,
            square: this.newObject.square,
            accident_insurance: this.newObject.accident_insurance,
            health_insurance: this.newObject.health_insurance,
            photo_path: this.newObject.photo_path,
            clients: JSON.stringify(this.newObject.clients),
            partners: JSON.stringify(this.newObject.organization),
          },
        }).then(() => {
          this.loadData();
          this.object_create_close();
        }).catch((response) => {
          this.alertMsg = this.$catch(response);
          this.alertError = true;
        }).then(() => {
          this.form_loader = false
        })
      } else {
        this.alertMsg = "Заполните все необходимые данные";
        this.alertError = true;
        this.form_loader = false
      }
    },
    delete_object() {
      this.$axios({
        url: this.$hostname + "time-tracking/objects",
        method: "DELETE",
        headers: {
          Authorization:
            "Token " +
            (localStorage.getItem("auth_token") ||
              sessionStorage.getItem("auth_token")),
          "Content-Type": "multipart/form-data",
        },
        data: {
          id: this.currentObject.id,
        },
      })
        .then(() => {
          this.loadData();
        })
        .catch((response) => {
          this.alertMsg = this.$catch(response);
          this.alertError = true;
        });
    },

    object_create_open() {
      if (this.object_action === "edit" || this.object_action === "copy") {
        let tmp_object = this.row_objects.filter((c) => {
          return c.id == this.chosen_id;
        })[0];
        this.newObject = {
          id: this.chosen_id,
          country: tmp_object.country,
          name: tmp_object.name,
          number: tmp_object.number,
          index: tmp_object.index,
          city: tmp_object.city,
          street: tmp_object.street,
          house: tmp_object.house,
          entrance: tmp_object.entrance,
          flat: tmp_object.flat,
          date_start: tmp_object.date_start,
          date_end: tmp_object.date_end,
          active: tmp_object.active,
          client_id: tmp_object.client_id ? tmp_object.client_id.id : null,
          org_client: tmp_object.org_client ? tmp_object.org_client.id : null,
          habitation: tmp_object.habitation,
          square: tmp_object.square,
          accident_insurance: tmp_object.accident_insurance,
          health_insurance: tmp_object.health_insurance,
          photo_path: tmp_object.photo_path,
          organization: tmp_object.organization,
        };
        this.$axios({
          url: this.$hostname + "time-tracking/object-client/" + this.newObject.id,
          method: "GET",
          headers: {
            Authorization:
              "Token " +
              (localStorage.getItem("auth_token") ||
                sessionStorage.getItem("auth_token")),
            "Content-Type": "multipart/form-data",
          },
        }).then((response) => {
          this.newObject.clients = response.data.data.data;
          this.$forceUpdate()
        }).catch((response) => {
          this.alertMsg = this.$catch(response);
          this.alertError = true;
        });
        this.obj_works = JSON.parse(tmp_object.work_description)
        this.photo = null
        if (this.object_action === "copy") {
          delete this.newObject.id
          delete this.newObject.number
          this.object_action = "add"
        }
      } else {
        this.object_action = "add"
        this.newObject = {
          country: "Suomi",
          name: "",
          index: "",
          city: "",
          street: "",
          house: "",
          entrance: "",
          flat: "",
          date_start: "",
          date_end: "",
          active: false,
          client_id: "",
          habitation: null,
          accident_insurance: null,
          health_insurance: null,
          photo_path: null,
        };
        this.photo = null
      }

      this.object_create_step = 1;
      this.object_create_modal = true;
      this.alertError = false
    },

    object_create_close() {
      this.object_create_modal = false;
    },

    obj_work_add() {
      this.obj_works.push(this.obj_work);
      this.obj_work = "";
    },
    nextStep() {
      if (this.$refs.form.validate()) {
        this.object_create_step++;
      }
    },
    uploadFile() {
      this.form_loader = true
      if (this.photo != null) {
        this.$axios({
          url: this.$hostname + "time-tracking/images/upload/objects",
          method: "POST",
          headers: {
            "Content-Type": "multipart/form-data",
          },
          data: {
            file: this.photo,
          },
        }).then((response) => {
          this.newObject.photo_path = response.data.data;
          this.confirm_object()
        }).catch((error) => {
          alert("Ошибка загрузки файла: " + error.message);
        })
      } else {
        this.confirm_object()
      }
    },

    acceptInvitation(id) {
      this.$axios({
        url: this.$hostname + "time-tracking/invitations/approve",
        method: "DELETE",
        headers: {
          Authorization:
            "Token " +
            (localStorage.getItem("auth_token") ||
              sessionStorage.getItem("auth_token")),
          "Content-Type": "multipart/form-data",
        },
        data: {
          id: id,
        },
      }).then(() => {
        this.loadData();
        this.loadInvitations();
      }).catch((response) => {
        this.alertMsg = this.$catch(response);
        this.alertError = true;
      });
    },
    rejectInvitation(id) {
      this.$axios({
        url: this.$hostname + "time-tracking/invitations",
        method: "DELETE",
        headers: {
          Authorization:
            "Token " +
            (localStorage.getItem("auth_token") ||
              sessionStorage.getItem("auth_token")),
          "Content-Type": "multipart/form-data",
        },
        data: {
          id: id,
        },
      }).then(() => {
        this.loadData();
        this.loadInvitations();
      }).catch((response) => {
        this.alertMsg = this.$catch(response);
        this.alertError = true;
      });
    },

    saveSettings() {
      let order = []
      this.headers.forEach(header => {
        order.push(header.key)
      })
      this.showHeaders.order = order
      this.tableSettings.objects = this.showHeaders
      this.$axios({
        url: this.$hostname + "time-tracking/user-settings/table-settings",
        method: "PUT",
        headers: {
          Authorization:
            "Token " +
            (localStorage.getItem("auth_token") ||
              sessionStorage.getItem("auth_token")),
          "Content-Type": "multipart/form-data",
        },
        data: {
          table_settings: JSON.stringify(this.tableSettings)
        }
      }).then(() => {
        this.settingsModal = false
      }).catch((response) => {
        this.alertMsg = this.$catch(response)
        this.alertError = true
      })
    },

    set_sort(field) {
      if (this.sort.includes(field) && this.sort[0] != '-') {
        this.sort = '-' + field
      } else {
        this.sort = field
      }
    },
  },

  watch: {
    type: function (val) {
      localStorage.setItem("type_objects", val);
    },
    sort: function () {
      this.loadData()
    },
    arch: function () {
      this.loadData()
    },
    perPage: function () {
      if ((this.page * this.perPage) > (this.page * this.objects.length))
        this.page = 1
      this.loadData()
    },
    range: function () {
      if (this.range.length == 2)
        this.loadData()
    },
    with_arch: function () {
      if (this.range.length) {
        this.loadData()
      }
    },
    future: function () {
      this.loadData()
    }
  },

  computed: {

    ...mapGetters(['permissions'])
  }
}
;
</script>
